export const EVENT_APPRAISER_ASSIGNMENT_STATUS = {
  ASSIGNED: 0,
  REMOVED: 1,
  ACCEPTED: 2,
  REJECTED: 3,
  PENDING_CONFIRMATION: 4
};
